var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"style-msg2 errormsg"},[_c('div',{staticClass:"msgtitle"},[_vm._v("Σφάλματα:")]),_c('div',{staticClass:"sb-msg"},[_c('ul',_vm._l((_vm.alerts),function(alert){return _c('li',{key:alert},[_vm._v(_vm._s(alert))])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }